import {Component, OnInit} from '@angular/core';
import { ApiAmenaService, ENTREGA_SIM_TIENDA, ENTREGA_SIM_LOGISTICA } from '../../services/api-amena.service';
import { MobilePackService } from '../../services/mobile-pack.service';

@Component({
    selector: 'app-user-activacion-tienda',
    templateUrl: './user-activacion-tienda.component.html',
    styleUrls: ['./user-activacion-tienda.component.css', '../../../../assets/css/amena-theme.css'],
    standalone: false
})
export class UserActivacionTiendaComponent implements OnInit {
    public pdv;

    constructor(
        private amenaService: ApiAmenaService,
        private mobilePackService: MobilePackService
    ) {
    }

    ngOnInit(): void {
        this.amenaService.getPDV().subscribe(data => {
            this.pdv = data;
        });
    }

    entregarSimEnTienda() {
        // Cambiamos los permisos temporalmente al PDV para que no se muestren las opciones en movilpack
        this.pdv.permissions.AMENA_VENTA_DE_TERMINALES = 'NO_PERMITE_LA_VENTA_DE_TERMINALES';
        this.amenaService.setPDV(this.pdv);
        // this.amenaService.setEntregaSim(ENTREGA_SIM_TIENDA);
        console.log(this.pdv);
        this.mobilePackService.setRetryValidators(true);
    }

    entregarSimLogistica() {
        this.pdv.permissions.AMENA_ACTIVACION_SIM = 'NO_PERMITE_ACTIVACION_SIM';
        console.log(this.pdv);
        this.amenaService.setPDV(this.pdv);
        // this.amenaService.setEntregaSim(ENTREGA_SIM_LOGISTICA);
        this.mobilePackService.setRetryValidators(true);
    }
}
